import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Twitter, Github, Mail, Phone, MapPin } from "lucide-react";
import Logo from "./Logo";
import { CONTACT } from "../data/modules";

const social = [
  { href: CONTACT.linkedin, label: "LinkedIn", Icon: Linkedin },
  { href: CONTACT.twitter, label: "Twitter", Icon: Twitter },
  { href: CONTACT.github, label: "GitHub", Icon: Github },
];

export const Footer = () => {
  const year = new Date().getFullYear();
  const footerModules = [
    { slug: "attendance", label: "Attendance" },
    { slug: "leaves", label: "Leaves" },
    { slug: "projects", label: "Projects" },
    { slug: "sprints", label: "Sprints" },
    { slug: "tasks", label: "Global Tasks" },
    { slug: "timesheets", label: "Timesheets" },
    { slug: "expenses", label: "Expenses" },
    { slug: "onboarding", label: "Onboarding" },
  ];

  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 bg-[#0A0A0A]"
    >
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-8">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-6">
          {/* Brand */}
          <div className="col-span-2 md:col-span-2">
            <Logo />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60">
              The modern workspace that unifies HR, project management, and
              everything in between — so teams that ship can stay in flow.
            </p>
            <div className="mt-6 flex gap-3">
              {social.map(({ href, label, Icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={label}
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  className="grid h-10 w-10 place-items-center rounded-full border border-white/10 text-white/70 transition-colors hover:border-[#4C6EF5]/60 hover:text-white"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Product */}
          <div>
            <h3 className="font-mono-label text-xs uppercase tracking-widest text-white/50">
              Product
            </h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/features" className="text-white/70 hover:text-white">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/features" className="text-white/70 hover:text-white">
                  All modules
                </Link>
              </li>
              <li>
                <a href="#" className="text-white/70 hover:text-white">
                  Sign in
                </a>
              </li>
              <li>
                <Link to="/contact" className="text-white/70 hover:text-white">
                  Book a demo
                </Link>
              </li>
            </ul>
          </div>

          {/* Modules */}
          <div>
            <h3 className="font-mono-label text-xs uppercase tracking-widest text-white/50">
              Modules
            </h3>
            <ul className="mt-4 space-y-3 text-sm">
              {footerModules.map((m) => (
                <li key={m.slug}>
                  <Link
                    to={`/features#${m.slug}`}
                    className="text-white/70 hover:text-white"
                  >
                    {m.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-mono-label text-xs uppercase tracking-widest text-white/50">
              Contact
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-white/70">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-[#8FA4FF]" />
                <a href={`mailto:${CONTACT.emailSales}`} className="hover:text-white">
                  {CONTACT.emailSales}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-[#8FA4FF]" />
                <a href={`tel:${CONTACT.phone}`} className="hover:text-white">
                  {CONTACT.phone}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-[#8FA4FF]" />
                {CONTACT.hq}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-sm text-white/50 sm:flex-row sm:items-center">
          <span>© {year} Velacin. All rights reserved.</span>
          <span className="font-mono-label text-xs uppercase tracking-widest">
            Built for teams that ship.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
